exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".flag__3ElLU{display:inline-block;margin-right:.5em;height:1em;width:1.5em;-o-object-fit:cover;object-fit:cover;border:1px solid #fff}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/C:/dev/globalTopBar/src/components/sections/personal-area/sections/user/language-flag-icon/styles.scss"],"names":[],"mappings":"AAAA,aACE,qBACA,kBACA,WACA,YACA,oBAAA,iBACA,qBAAuB,CACxB","file":"styles.scss","sourcesContent":[".flag {\n  display: inline-block;\n  margin-right: .5em;\n  height: 1em;\n  width: 1.5em;\n  object-fit: cover;\n  border: 1px solid white;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"flag": "flag__3ElLU"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/sections/personal-area/sections/user/language-flag-icon/styles.scss
// module id = kyfi
// module chunks = 0